export default __webpack_public_path__ + "static/media/google-search-console-gris.00acf794.png";